import styled from "styled-components";

export const ProductWarrantyCreateFormStyled = styled.div`
  .input_wrap {
    margin-bottom: 20px;
    max-width: 60%;
  }
  .action_row {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    column-gap: 10px;
    .w120 {
      width: 120px;
    }
  }
`;
